import {
  Button,
  Checkbox,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { useRef } from "react";

type FilterTemplateSaveModalProps = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly defaultName?: string;
  readonly isLoading?: boolean;
  readonly onlyForMe: boolean;
  readonly onOnlyForMeChange: (value: boolean) => void;
  readonly onConfirm: (name: string) => void;
};

export function FilterTemplateSaveModal({
  isOpen,
  onClose,
  defaultName = "",
  isLoading,
  onlyForMe,
  onOnlyForMeChange,
  onConfirm,
}: FilterTemplateSaveModalProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleConfirm = () => {
    const name = inputRef.current?.value.trim();
    if (!name) return;
    onConfirm(name);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (isLoading) return;
        onClose();
      }}
      size="sm"
      trapFocus={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Trans>Save filter template</Trans>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing="3">
            <Input
              key={defaultName}
              ref={inputRef}
              autoFocus
              defaultValue={defaultName}
              onKeyDown={(event) => {
                if (event.key === "Enter") handleConfirm();
              }}
              placeholder={t`Template name`}
            />
            <Checkbox
              isChecked={onlyForMe}
              onChange={(event) => {
                onOnlyForMeChange(event.target.checked);
              }}
            >
              <Trans>Only for me</Trans>
            </Checkbox>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="grey"
            isLoading={isLoading}
            onClick={onClose}
            variant="outline"
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button ml="3" isLoading={isLoading} onClick={handleConfirm}>
            <Trans>Save</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
